import { useCallback } from 'react';

import { useTickets } from 'contexts/TicketsContext';
import type { NoopT } from 'declarations/types/common';

type UseOpenROListPopupT = {
  isPopupOpened: boolean;
  handleCloseROListPopup: NoopT;
};

const useOpenROListPopup = (): UseOpenROListPopupT => {
  const { setROListPopupVisibility, isROListPopupOpened } = useTickets();

  const handleCloseROListPopup = useCallback(() => {
    setROListPopupVisibility(false);
  }, [setROListPopupVisibility]);

  return {
    isPopupOpened: isROListPopupOpened,
    handleCloseROListPopup,
  };
};

export default useOpenROListPopup;
